import { createTripArrayFieldMachine } from './createTripArrayFieldMachine';

export const dropoffAddressMachine =
  createTripArrayFieldMachine('dropoffAddress');
